const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c56bee38608c5dbe64eb27d063bacb4f34d810e2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wearehome@patronage"]={id:"c56bee38608c5dbe64eb27d063bacb4f34d810e2"};
      